// extracted by mini-css-extract-plugin
export var layout = "LayoutV2-module--layout--3vKUR";